<template>
  <div>
    <headTop />
    <LoopImg />
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }" class="home">{{ $t('navbar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('navbar.exhibits') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <span>{{ $t('navbar.exhibits') }}</span>
        </div>
        <div class="content">
          <div class="screenMain">
            <el-row>
              <el-col :span="6">
                <div class="leftMain">
                  <!-- 搜索框以及按钮 -->
                  <div class="search">
                    <el-input :placeholder="$t('exhibits.placeholder')" class="input-with-select" v-model="keyWords">
                      <el-button slot="append" @click="exhibitSearch()">
                        <i class="el-icon-search"></i>
                      </el-button>
                    </el-input>
                  </div>

                  <!-- 按产品类型筛选 -->
                  <div class="screen">
                    <div class="screenTitle" @click="arrowToggle()">
                      <div class="left"  :title="screenList.title">
                        {{ screenList.title }}
                      </div>
                      <!-- 右侧小箭头 -->
                      <div class="right">
                        <i class="el-icon-arrow-up" v-if="open"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                      </div>
                    </div>
                    <!-- 按产品类型筛选的下级栏目列表显示与隐藏 -->
                    <div class="screenCondition" :style="{ display: open ? 'block' : 'none' }">
                      <!-- 按产品类型筛选的下级栏目列表 -->
                      <ul>
                        <li v-for="(i, k) in screenList.conditons" :key="k" class="hoverStyle" @mouseenter="hoverIn(k)" :title="i.title">
                          <el-checkbox @change="checkLi(i)" v-model="i.choose">{{ i.title }}</el-checkbox>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- 按展馆筛选 -->
                  <!-- 鼠标移入的时候右侧出现的面板信息------------------------------------------------------------------->
                  <div
                    class="secondCategory"
                    :style="{
                      display: secordDisplay ? 'block' : 'none',
                      zIndex: secordDisplay ? '10000' : '',
                    }"
                    @mouseleave="hoverOut()"
                  >
                    <el-card class="box-card">
                      <div class="box" v-for="(ite, k) in secordList" :key="k">
                        <div class="title1">
                          <el-checkbox @change="checkAlll(ite)" v-model="ite.choose">{{ ite.title }}</el-checkbox>
                        </div>

                        <div class="body">
                          <el-checkbox @change="checkChild(ite, item)" v-model="item.choose" v-for="(item, index) in ite.children" :key="index">{{
                            item.title
                          }}</el-checkbox>
                        </div>
                      </div>
                    </el-card>
                  </div>

                  <!-- 鼠标移入的时候右侧出现的面板信息------------------------------------------------------------------------>
                </div>
              </el-col>

              <!-- 右边的内容框开始 -->
              <el-col :span="18">
                <div class="rightMain">
                  <!-- 右侧顶部的筛选条件的 -->
                  <div
                    class="rightTitle"
                    :style="{
                      display: dynamicTags.length > 0 ? 'block' : 'none',
                    }"
                  >
                    <!--筛选条件框-->
                    <el-row class="selectt">
                      <div class="text">{{ $t('common.screenConditions') }}</div>
                      <!--tags标签 -->
                      <div>
                        <el-tag :key="k" v-for="(tag, k) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)" v-model="dynamicTags">
                          {{ tag.name }}
                        </el-tag>
                      </div>
                      <!-- 清空按钮 -->
                      <div class="clear">
                        <el-button icon="el-icon-delete" type="primary" @click="clearTag()">{{ $t('common.clear') }}</el-button>
                      </div>
                    </el-row>
                  </div>
                  <!-- 右侧顶部的筛选框结束 -->

                  <!-- 右侧的内容区域 -->
                  <div
                    class="rightContent"
                    :style="{
                      marginTop: dynamicTags.length > 0 ? '20px' : '0',
                    }"
                  >
                    <!-- 右侧内容区域的子栏目开始 -->
                    <div v-if="RecommendExhibits.length === 0" class="emptyStyle">
                      <img src="../../static/empty.png" alt="" />
                      <div class="promptInfo">{{ $t('exhibits.noData') }}</div>
                    </div>
                    <div class="rightBox" v-for="(item, index) in RecommendExhibits" :key="index" @click="goDetail(item.id)" v-else>
                      <div>
                        <div class="fixHigh">
                          <div class="titl comment">{{ lang == 'zh' ? item.exhibitsName:item.column25?item.column25:item.exhibitsName }}</div>
                          <div class="english comment">{{ item.column23 }}</div>
                          <div class="txt">{{ item.column17 }}</div>
                          <div class="boothName"><span>{{ $t('exhibition.boothNum') }}</span>：{{ item.hzBooth.boothNum }}</div>
                        </div>
                        <div class="backImg">
                          <img :src=" item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.includes('/')" />
                          <img src="../../static/占位-展品-列表.png" alt="" v-else />
                        </div>
                        <div class="companyName">
                          <span class="leftTitle">{{ lang== 'zh' ? item.hzExhibitor.companyNameC :  item.hzExhibitor.companyNameE }}</span>
                          <span class="rightIcon" @click.stop="consult(item)">
                            <img src="../../static/consulting.png" alt="" />
                            <div class="hoversty">{{ $t('common.consult') }}</div>
                          </span>
                        </div>
                      </div>

                      <div class="boxBottom">
                        <span class="bottomTxt comment"> {{ $t('common.more') }}</span>
                        <span class="bottomImg">
                          <img
                            :src="item.collectStatus ? require('../../static/collent_yello.png') : require('../../static/collen1t.png')"
                            alt=""
                            @click.stop="toggle(item)"
                          />
                          <div class="hoversty">{{ item.collectStatus ? $t('common.clearCollect') : $t('common.collect') }}</div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 右侧内容区域的子栏目结束  -->
          <div class="pagination">
            <span>{{ $t('common.pagination', { allNum: countALL }) }}</span>
            <el-pagination
              v-if="pageshow"
              class="explore_right_pages"
              layout="prev, pager, next"
              :current-page="currentPage4"
              @current-change="handleCurrentChange"
              :page-size="18"
              :total="countALL"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <footBottom />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import loopImg from '../../common/loopImg.vue';
import footBottom from '../../common/footBottom.vue';
import { searchExhibits, collecExhibit } from '../../../api/exhibitProduct.js';
// import * as funApi from "../../../Json/exhiList_20210715"
import { screenList } from '../../../Json/screenList';
import { screenListEn } from '../../../Json/screenListEn.js';
import * as tools from '../../../utils/roulink';
import { forMat } from '../../../utils/common.js';
 import LoopImg from './loopImg.vue';
export default {
  components: {
    headTop,
    footBottom,
    LoopImg,
  },
  data() {
    return {
      baseUrl: forMat(),
      keyWords: '',
      //右侧内容区域的内容数组
      RecommendExhibits: [],
      currentPage4: 1, //分页当前页
      hoverIndex: '',
      //面板信息数组
      secordList: [],
      //控制面板信息
      secordDisplay: false,
      //按产品类型筛选
      screenList,

      //按展馆筛选

      //控制按产品类型筛选的折叠收起
      open: true,
      //控制按展馆筛选的折叠收起
      openEx: true,
      tags: [],
      //右侧筛选框的tag标签
      dynamicTags: [],
      countALL: 18,
      pageshow: true,
      lang: 'zh'
    };
  },

  methods: {
    consult(item) {
      tools.login(1, item.hzExhibitorId);
    },
    // 产品类型json处理
    jsonDetail() {
      var json = funApi.default;
      var lastDate = {
        title: this.$t('common.screen1'),
        conditons: json,
      };
      for (let i = 0; i < json.length; i++) {
        json[i].id = i + 1;
        json[i].choose = false;
        let itemchild = json[i].child;
        // console.log(itemchild);
        for (const key in itemchild) {
          delete itemchild[key].folding;
          itemchild[key].id = Number(key) + 1;
          itemchild[key].choose = false;
          // console.log(itemchild[key])
          let lastchild = itemchild[key].child;
          for (const v in lastchild) {
            if (lastchild.hasOwnProperty.call(lastchild, v)) {
              const element = lastchild[v];
              element.id = Number(v) + 1;
              element.choose = false;
              console.log(element);
            }
          }
        }
      }
      this.screenList = lastDate;
      console.log(this.screenList);
    },
    // 切换产品的收藏
    async toggle(item) {
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.msg,
          //   type: 'warning',
          // });
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    //分页点击事件
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      var exhibitsType = [];
      if (this.dynamicTags.length > 0) {
        this.dynamicTags.map((item) => {
          exhibitsType.push(item.type);
        });
      }
      const params = {
        page: val,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.getSearchData(params);
    },
    //产品类型筛选点击事件
    checkLi(i) {
      this.deSelect(i);
    },

    //取消选择
    deSelect(i) {
      if (i.choose) {
        i.title.length > 2 ? this.dynamicTags.push({ index: i.id, name: i.title,type: i.type }) : this.dynamicTags.push({ index: i.id, name: i.title + '馆' });
      } else {
        for (let item in this.dynamicTags) {
          i.id == this.dynamicTags[item].index ? this.dynamicTags.splice(item, 1) : console.log('失败');
        }
      }
    },

    //tags删除取消事件
    handleClose(tag) {
      this.matchTag(tag.name, this.screenList.conditons);
      this.tagDel(tag);
      this.matchTree(tag.name, this.screenList.conditons[this.hoverIndex].children);
    },
    matchTree(tag, arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].children.map((item) => {
          if (tag == item.title) {
            item.choose = false;
            arr[i].choose = false;
            return false;
          }
        });
      }
    },
    //tag标签删除
    tagDel(tag) {
      const i = this.dynamicTags.findIndex((item) => {
        return item.index == tag.index;
      });
      this.dynamicTags.splice(i, 1);
    },
    //tags左侧匹配事件
    matchTag(val, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (val == arr[i].title) {
          arr[i].choose = false;
          return false;
        }
      }
    },

    //清空所有tags标签   -----存在小bug,全部删除时，信息面板勾选的没取消---------------------------------------
    clearTag() {
      this.dynamicTags = [];
      //清空按产品类型筛选
      this.screenList.conditons.forEach((element) => {
        element.choose = false;
        element.children.forEach((i) => {
          i.choose = false;
          i.children.forEach((v) => {
            v.choose = false;
          });
        });
      });

      this.secordList.forEach((item) => {
        item.choose = false;
        item.children.forEach((i) => {
          i.choose = false;
        });
      });
    },

    //产品类型筛选的鼠标移入事件
    hoverIn(index) {
      this.hoverIndex = index;
      this.secordDisplay = true;
      this.secordList = [];
      this.secordList = this.screenList.conditons[index].children;
    },

    //面板全选
    checkAlll(item) {
      console.log(item);
      if (item.choose) {
        item.children.map((item) => {
          item.choose = true;
          this.dynamicTags.push({ index: item.id, name: item.title, type:item.type });
          this.dynamicTags = this.unique(this.dynamicTags);
        });
      } else {
        item.children.forEach((i) => {
          i.choose = false;
          const index = this.dynamicTags.findIndex((k) => {
            return i.title == k.name;
          });
          this.dynamicTags.splice(index, 1);

          this.dynamicTags = this.unique(this.dynamicTags);
        });
      }
    },

    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1));
    },

    //面板单选
    checkChild(arr, item) {
      console.log('单选框item得值', item);
      console.log('单选框item得数组', arr);
      if (item.choose) {
        this.dynamicTags.push({ index: item.id, name: item.title, type:item.type });
        const flag = arr.children.every((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = true) : console.log('');
        console.log('处理完得数组', this.arr);
      } else {
        const index = this.dynamicTags.findIndex((i) => {
          return i.name == item.title;
        });
        this.dynamicTags.splice(index, 1);
        const flag = arr.children.some((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = false) : console.log('');
      }
    },

    //产品类型筛选的鼠标移出事件
    hoverOut() {
      this.secordDisplay = false;
    },
    //折叠按钮
    arrowToggle() {
      this.open = !this.open;
    },
    //折叠按钮
    arrowToggleEx() {
      this.openEx = !this.openEx;
    },
    async exhibitSearch() {
      // 点击搜索按钮进行搜索
      var exhibitsType = [];
      if (this.dynamicTags.length > 0) {
        this.dynamicTags.map((item) => {
          exhibitsType.push(item.type);
        });
      }
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.getSearchData(params);
    },

    async getSearchData(params) {
      console.log('被拦截的参数', params);
      const { data } = await searchExhibits(params);
      this.countALL = data.data.count;
      if (data.data.list?.length > 0) {
        this.RecommendExhibits = data.data.list;

        this.RecommendExhibits.forEach((item, i) => {
          if(item.exhibitsCoverImg.indexOf("http")  == -1){
            this.RecommendExhibits[i].exhibitsCoverImg= forMat() +   this.RecommendExhibits[i].exhibitsCoverImg;
          }
        })

        

        this.countALL = data.data.count;
      } else {
        this.RecommendExhibits = [];
      }
    },
    goDetail(id) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id,
        },
      });
    },
    initData() {
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: [],
          keyword: '',
        },
      };
      this.getSearchData(params);
    },
    clickOutside() {
      var btn = document.querySelector('.secondCategory');
      if (btn) {
        if (!btn.contains(event.target)) {
          this.secordDisplay = false;
        }
      }
    },
    getQueryString(query) {
      const obj = this.$router.history.current.query;
      if (obj[query]) {
        return obj[query];
      } else {
        return '';
      }
    },
  },
  mounted() {
    window.addEventListener('click', this.clickOutside);
  },
  watch: {
    keyWords(newValue, oldValue) {
      this.keyWords = newValue;
    },
    dynamicTags(newValue, oldValue) {
      var exhibitsType = [];
      newValue.map((item) => {
        exhibitsType.push(item.type);
      });
      const params = {
        page: 1,
        size: 18,
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
        },
      };
      this.currentPage4 = 1
      this.pageshow = false;
      this.getSearchData(params);
      this.$nextTick(() => {
        this.pageshow = true;
      });
      const type = exhibitsType.toString();
      const href = window.location.href;
      if (newValue.length == 0) {
        const href = window.location.href;
        const arr = href.split('?');
        window.location.href = arr[0];
      } else {
        const arr = href.split('?')[0];
        window.location.href = arr + '?type=' + type;
      }
    },
  },
  created() {
    this.lang =localStorage.getItem('lang')
    if(this.lang == 'en'){
      this.screenList = screenListEn
    }else {
      this.screenList = screenList
    }
    const href = window.location.href;
    const type = this.getQueryString('type');
    if (type) {
      const arr = type.split(',');
      arr.map((item) => {
        this.screenList.conditons.map((i) => {
          if (decodeURIComponent(item) === i.type) {
            i.choose = true;
            this.dynamicTags.push({ index: i.id, name: i.title, type:i.type });
          }
        });
      });
    } else if (href.includes('?')) {
      const arr = decodeURI(href).split('?');
      const newArr = arr[1].split('&');
      // 类型
      let type;
      if (newArr[0].includes('=')) {
        type = newArr[0].split('=');
        console.log(type);
        if (type[1] == '') {
          type = '';
        }
      } else {
        type = '';
      }
      let keyword;
      // 关键字
      if (newArr[1]) {
        keyword = newArr[1].split('=')[1];
      } else {
        keyword = '';
      }
      if (type != '') {
        const params = {
          page: 1,
          size: 18,
          value: {
            exhibitsType: type,
            keyword: keyword,
          },
        };
        this.getSearchData(params);
      } else {
        const params = {
          page: 1,
          size: 18,
          value: {
            keyword: keyword,
          },
        };
        console.log('执行的展品无类型的数据的查询');
        this.getSearchData(params);
      }
    } else {
      this.initData();
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #f6f6f7;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  // margin-top: 100px;
  .main {
    padding-top: 23px;
    box-sizing: border-box;
    margin: 0 auto;
    // margin-bottom: 62px;
    width: 1270px;
    .breadcrumb {
      a {
        color: #006fb8;
      }
    }
    .title {
      margin-top: 46px;
      span {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
    .content {
      padding-bottom: 60px;
      .screenMain {
        width: 100%;
        .leftMain {
          margin-top: 20px;
          width: 295px;
          // border: 1px solid rgb(0, 0, 0);
          .search {
            width: 100%;
            height: 40px;
            .input-with-select {
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              color: #999999;
              .el-button {
                width: 70px;
                height: 40px;
                background: #006fb8;
                border-radius: 0px 4px 4px 0px;
                i {
                  width: 24px;
                  height: 24px;
                  color: white;
                  line-height: 20px;
                }
              }
            }
          }

          .screen {
            margin-top: 20px;
            width: 100%;
            position: relative;
            .screenTitle {
              width: 100%;
              height: 50px;
              background: #006fb8;
              padding: 0 14px 0 30px;
              line-height: 50px;
              box-sizing: border-box;
              display: inline-block;
              .left {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                float: left;
                width: 220px;
                white-space:nowrap; 
                overflow:hidden; 
                text-overflow:ellipsis; 
              }
              .right {
                float: right;
                width: 24px;
                height: 24px;
                color: white;
              }
            }
            .screenCondition {
              width: 100%;
              background-color: white;
              ul {
                padding-bottom: 10px;
                box-sizing: border-box;
              }
              li {
                padding: 0;
                margin: 0;
                list-style: none;
                .el-checkbox {
                  margin-left: 30px;
                  line-height: 40px;
                  height: 40px;
                }
              }
              ul li:hover {
                background: #f4f4f4;
                .el-checkbox {
                  color: #006fb8;
                }
              }
              ul li:hover:before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 40px;
                line-height: 40px;
                opacity: 1;
                background: #fccf00;
                position: absolute;
              }
              ul li:hover .secondCategory {
                display: block;
              }
            }
          }
          .exhibitionList {
            margin-top: 20px;
            width: 100%;
            position: relative;
            .screenTitle {
              width: 100%;
              height: 50px;
              background: #006fb8;
              padding: 0 14px 0 30px;
              line-height: 50px;
              box-sizing: border-box;
              display: inline-block;
              .left {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                float: left;
              }
              .right {
                float: right;
                width: 24px;
                height: 24px;
                color: white;
              }
            }
            .screenCondition {
              width: 100%;
              background-color: white;
              float: left;
              ul {
                padding-bottom: 10px;
                box-sizing: border-box;
              }
              li {
                padding: 0;
                margin: 0;
                list-style: none;
                .el-checkbox {
                  margin-left: 30px;
                  line-height: 40px;
                  height: 40px;
                }
              }
              ul li:hover .secondCategory {
                display: block;
              }
            }
          }
          .secondCategory {
            position: absolute;
            left: 295px;
            top: 80px;
            display: none;
            // border: 1px solid red;
            z-index: 1222222;
            width: 750px;
            // height: 630px;
            height: auto;

            .box-card {
              width: 100%;
              min-height: 484px;
              // background-color: skyblue;
              .box {
                width: 100%;
                // border: 1px solid red;
                margin-bottom: 20px;
                .title1 {
                  padding-bottom: 5px;
                  margin-bottom: 18px;
                  border-bottom: 1px solid #e0e0e0;
                  font-weight: bold;
                  .el-checkbox {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                  }
                }
                .body {
                  .el-checkbox {
                    margin-bottom: 10px;
                  }
                }
              }
            }
          }
        }
        .rightMain {
          margin-top: 20px;

          .rightTitle {
            width: 100%;
            // border: 1px solid red;
            .selectt {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 10px;
              .disp {
                margin-left: 11px;
              }
              .clear {
                margin-left: 11px;
                button {
                  margin-bottom: 10px;
                }
              }
            }

            .text {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
            }
            .el-button--primary {
              width: 80px;
              height: 40px;
              background: #006fb8;
              border-radius: 4px;
              text-align: center;
            }
            .myList {
              display: inline-block;
            }
            ul li {
              display: inline;
            }
          }
          .rightContent {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            width: 980px;
            .emptyStyle {
              width: 100%;
              height: 100%;
              text-align: center;
              line-height: 300px;
              position: relative;
              .promptInfo {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                position: absolute;
                top: 135px;
                left: 450px;
              }
            }
            .rightBox {
              width: 294px;
              height: fit-content;
              // border: 1px solid rgb(0, 8, 255);
              background-color: white;
              margin-bottom: 28px;
              margin-right: 30px;
              border: 1px solid #e0e0e0;
              .fixHigh {
                height: 112px;
                .titl {
                  font-size: 24px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  margin-top: 34px;
                  margin-left: 24px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  word-break: break-all;
                  max-width: 250px;
                }
                .english {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #333333;
                  margin-top: 9px;
                  margin-left: 24px;
                  line-height: 16px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  max-width: 250px;
                }
                .txt {
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  margin-top: 11px;
                  margin-left: 24px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  line-height: 14px;
                  max-width: 250px;
                }
                .boothName {
                  font-size: 16px;
                  font-weight: 400;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #000000;
                  margin-top: 11px;
                  margin-left: 24px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  line-height: 14px;
                  max-width: 250px;
                }
              }

              .backImg {
                width: 226px;
                height: 172px;
                margin: 27px 0px 0px 24px;
                justify-content: center;
                align-items: center;
                display: flex;
                img {
                  max-width: 100%;
                  max-height: 100%;
                  vertical-align: middle;
                }
              }
              .companyName {
                margin: 19px 24px 20px 24px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                position: relative;
                .leftTitle {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  width: 203px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 203px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .rightIcon {
                  width: 18px;
                  height: 18px;
                  margin-left: 6px;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                  .hoversty {
                    width: 96px;
                    height: 40px;
                    background: #000000;
                    opacity: 0.7;
                    border-radius: 4px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ffffff;
                    display: none;
                    text-align: center;
                    position: absolute;
                    top: -8px;
                    right: -78px;
                    line-height: 40px;
                    cursor: pointer;
                  }
                }
                .rightIcon:hover .hoversty {
                  display: block;
                }
              }

              .boxBottom {
                height: 68px;
                width: 295px;
                border-radius: 1px;
                border-top: 1px solid #e0e0e0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .bottomTxt {
                  margin-left: 24px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                }
                .bottomImg {
                  width: 30px;
                  height: 28px;
                  margin-right: 24px;
                  position: relative;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                  .hoversty {
                    width: 96px;
                    height: 40px;
                    background: #000000;
                    opacity: 0.7;
                    border-radius: 4px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ffffff;
                    display: none;
                    text-align: center;
                    position: absolute;
                    top: -6px;
                    left: 30px;
                    line-height: 40px;
                    cursor: pointer;
                  }
                }
                .bottomImg:hover .hoversty {
                  display: block;
                }
              }
              &:hover {
                .titl {
                  color: #006fb8;
                }

                .english {
                  color: #006fb8;
                }

                .boxBottom {
                  .bottomTxt {
                    color: #006fb8;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
      .pagination {
        display: flex;
        justify-content: center;
        // margin-bottom: 60px;

        span {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-top: 9px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-tag {
  margin-left: 10px !important;
  height: 40px !important;
  margin-bottom: 10px;
  line-height: 40px !important;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}

::v-deep .title1 .el-checkbox__label {
  font-size: 16px;
}

::v-deep .screen .el-checkbox__label {
  font-size: 16px;
}
</style>
<style scoped>
.search >>> .el-input__inner {
  font-size: 16px !important;
}
>>> .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 20px;
    font-size: 14px;
    white-space: nowrap;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}
</style>
